import { Component } from '@angular/core';
import { CmsComponentData } from "@spartacus/storefront";
import { CmsService } from "@spartacus/core";
import { map, switchMap } from "rxjs/operators";
import { combineLatest, Observable } from "rxjs";
import { CustomAccordionData } from "./custom-accordion.model";

@Component({
  selector: 'app-custom-accordion',
  templateUrl: './custom-accordion.component.html',
  styleUrls: ['./custom-accordion.component.scss'],
  standalone: false
})
export class CustomAccordionComponent {

  constructor(private componentData: CmsComponentData<CustomAccordionData>, private cmsService: CmsService) {}

  data$ = this.componentData.data$.pipe(map(component => component));

  items$: Observable<any[]> = this.componentData.data$.pipe(
    switchMap(data =>
      combineLatest(
        data.items.trim().split(' ').map((codes: any) => this.cmsService.getComponentData(codes).pipe(
          map(tab => tab)
        )))
    ));
}
